
export * from '../../frontend-editor-ckeditor-web/__liferay__/exports/ckeditor5.js';
